import { httpApi } from '@app/api/http.api'

export type DeviceTemplate = {
  [key: string]: any
}

export type Device = {
  id: string
  name: string
  serialNumber: string
  resource?: number
  latitude?: number
  longitude?: number
  serviceUDTDate?: string
  udtNumber: string
  inspections?: any[]
  alertStatus?: 'normal' | 'warning' | 'critical' | string
  deviceTemplates?: DeviceTemplate[]
  deviceStatusDataType?: string
  deviceStatusIndex?: number
  language?: string
  resetTableData?: any[]
  resourceDataType?: string
  resourceIndex?: number
  resourceLabel?: string
}

export type Firm = {
  id: string
  name: string
  devices: Device[]
}

export type ProfileResponse = {
  id: string
  email: string
  firstName: string
  lastName: string
  role: string[]
  devices: Device[]
  firms: Firm[]
  mfaMethod?: string | null
  position?: string
  description?: string
}

export type ProfileDetailsResponse = {
  position: string
  description: string
}

export type UpdateProfilePayload = {
  id: string
  data: {
    firstName: string
    lastName: string
    position: string
    description: string
  }
}

export type ChangeProfilePasswordPayload = {
  id: string
  data: { oldPassword: string; newPassword: string }
}

export type ChangeProfileResponse = {
  message: string
}

const PROFILE = 'profile'

export const getProfile = (id: string): Promise<ProfileResponse> =>
  httpApi.get<ProfileResponse>(`${PROFILE}/${id}`).then(({ data }) => data)

export const getProfileDetails = (id: string): Promise<ProfileDetailsResponse> =>
  httpApi.get<ProfileDetailsResponse>(`${PROFILE}/details/${id}`).then(({ data }) => data)

export const updateProfile = ({ id, data }: UpdateProfilePayload): Promise<ChangeProfileResponse> =>
  httpApi.put<ChangeProfileResponse>(`${PROFILE}/${id}`, data).then(({ data }) => data)

export const changePassword = ({ id, data }: ChangeProfilePasswordPayload): Promise<ChangeProfileResponse> =>
  httpApi.put<ChangeProfileResponse>(`${PROFILE}/${id}/change-password`, data).then(({ data }) => data)
